export default class ShiftSwapNotificationModalCtrl {
  constructor(
    Authentication,
    EventCollection,
    PersonaCollection,
    toDateLongFilter,
    extendShiftModel,
    notification,
    sdk,
    swapDetails
  ) {
    'ngInject';

    Object.assign(this, {
      Authentication,
      EventCollection,
      PersonaCollection,
      toDateLongFilter,
      extendShiftModel,
      notification,
      sdk,
    });

    this.extendSwapDetails(swapDetails);
  }

  extendSwapDetails(swapDetails) {
    this.swapDetails = {
      ...swapDetails,
      offererShift: this.extendShiftModel(swapDetails.offererShift),
      offereeShift: this.extendShiftModel(swapDetails.offereeShift),
    };
    this.offerer = { ...this.PersonaCollection.personasDict[swapDetails.offerer.id] };
    this.offeree = { ...this.PersonaCollection.personasDict[swapDetails.offeree.id] };
    this.exchangeData = {
      amIOfferee: this.swapDetails.offeree.id === this.Authentication.user.id,
      amIOfferer: this.swapDetails.offerer.id === this.Authentication.user.id,
      swap: this.swapDetails,
    };

    this.offererShiftDescription = `${this.toDateLongFilter(
      swapDetails.offererShift.dtstart,
      'EEE'
    )} • ${this.swapDetails.offererShift.displayLabel}`;
    this.offereeShiftDescription = `${this.toDateLongFilter(
      swapDetails.offereeShift.dtstart,
      'EEE'
    )} • ${this.swapDetails.offereeShift.displayLabel}`;
  }

  get originalShiftDescription() {
    if (!this.swapDetails) {
      return '';
    }

    return this.sdk('descriptionHelpers').getOriginalShiftDescription(
      this.exchangeData.amIOfferer,
      this.offerer
    );
  }

  get goalShiftDescription() {
    if (!this.swapDetails) {
      return '';
    }

    return this.sdk('descriptionHelpers').getGoalShiftDescription(
      this.exchangeData.amIOfferee,
      this.offeree
    );
  }

  get shouldHideHourDifference() {
    return Boolean(
      this.swapDetails?.offererShift?.openEnd || this.swapDetails?.offereeShift?.openEnd
    );
  }

  get swapStatus() {
    if (!this.exchangeData) {
      return '';
    }
    return this.sdk('descriptionHelpers').getSwapStatusDescription(
      this.exchangeData,
      this.offeree,
      this.Authentication.user.orgSettings.shiftExchangeRequiresApproval
    );
  }
}
